// Sakura-Modern design tokens used by modern pages and charts.
export const ink = '#19233f';
// Sakura-Modern --muted-foreground (hsl 229 13% 41%).
export const muted = '#5b6076';
export const border = '#d8dfeb';
export const navy = '#1b2d5b';
export const burgundy = '#5b1535';
export const pink = '#f0365a';
// Sakura-Modern --primary (hsl 340 82% 52%) and --destructive.
export const primary = '#e92063';
export const destructive = '#c51111';

// Chart palette from Sakura-Modern index.css (--chart-1 … --chart-5).
export const chart = ['#e9256b', '#2938bf', '#00b8d6', '#f2bb0d', '#22c35e'];
// Sakura-Modern surfaces: --muted, --accent, --sidebar*.
export const mutedSurface = '#eef0f6';
export const accent = '#00bdd6';
export const success = '#059669'; // emerald-600
export const displayFont = '"DM Sans", Inter, system-ui, sans-serif';
export const sidebar = { bg: '#151c38', border: '#1c264a', accent: '#272f49', fg: '#fafafa' };
// app-sidebar.tsx STAR_THEME (tool card).
export const starTool = {
  text: '#5B1535', textMuted: '#7A2648', icon: '#F0365A', activeBg: 'rgba(240,54,90,0.10)', activeText: '#5B1535',
  headerBg: '#5B1535', headerText: '#ffffff',
};

export const chartColor = (index) => chart[index % chart.length];

export const zone = {
  acceptable: { fg: '#047857', bg: '#d1fae5', border: '#a7f3d0', tint: '#f0fdf4', label: 'Acceptable' },
  warning: { fg: '#b45309', bg: '#fef3c7', border: '#fde68a', tint: '#fffbeb', label: 'Warning' },
  risk: { fg: '#b91c1c', bg: '#fee2e2', border: '#fecaca', tint: '#fff1f2', label: 'At Risk' },
  unavailable: { fg: muted, bg: '#eef2f7', border: border, tint: '#f8fafc', label: 'No Data' },
};

export const cardStyle = {
  border: `1px solid ${border}`,
  borderRadius: 8,
  background: '#fff',
  boxShadow: '0 1px 2px rgba(23, 33, 61, 0.05)',
};
